import { IColumn } from './interfaces';

export const getUniqueIdentifier = (index: number) => index.toString();

export const getDraggableColumnNames = (columns: IColumn[]): string[] => columns
  .filter((col) => col.isDraggable !== false)
  .map((col) => col.name);

export const shouldShowLoader = ({
  isSkeletonEnabled,
  isFetching,
}: {
  isSkeletonEnabled?: boolean,
  isFetching?: boolean,
}) => {
  return !isSkeletonEnabled && isFetching;
};
